import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { adminMainUrl } from "../../../../../../../Config";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getCCExportConsigneeOrganisationBranchList, getCCExportOrganisationBranchList, getCCExportOrganisationList, getCCExportShipperOrganisationBranchList } from "../../../../../../../Redux/action/CustomClearance/CCAction";

const ShipperTab = ({
    token,
    user_id,
    b64id,
    refresh,
    loadingCCExpJobDetail,
    CCExpJobDetailData,
    CCExpJobDetailDataError,
    trans_mode,

    loadingCCShiplineList,
    loadingCCAirlineList,
    shiplineOptions,
    airlineOptions,
    loadingCCPortList,
    portOptions
}) => {


    const [disableSubmit, setDisableSubmit] = useState(false);
    const dispatch = useDispatch();


    const {
        loadingCCExpJobOrganisationList,
        CCExpJobOrganisationListData,
        CCExpJobOrganisationListDataError,

        loadingCCExpJobShipperOrganisationBranchList,
        CCExpJobShipperOrganisationBranchListData,
        CCExpJobShipperOrganisationBranchListDataError,
        loadingCCExpJobConsigneeOrganisationBranchList,
        CCExpJobConsigneeOrganisationBranchListData,
        CCExpJobConsigneeOrganisationBranchListDataError,

    } = useSelector(state => state?.CCReducer);

    useEffect(() => {
        if (user_id && token) {
            dispatch(getCCExportOrganisationList(token, user_id))
        }
    }, [user_id, token, b64id]);


    const [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    const [shipperBranchOrganisationOptions, setShipperBranchOrganisationOptions] = useState([]);
    const [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);
    const [consigneeBranchOrganisationOptions, setConsigneeBranchOrganisationOptions] = useState([]);

    useEffect(() => {
        if (CCExpJobOrganisationListData) {
            let arr = [];
            CCExpJobOrganisationListData.map(val => arr.push({ value: val.id, label: val.name }));
            setShipperOrganisationOptions(arr);
            setConsigneeOrganisationOptions(arr);
        }
    }, [loadingCCExpJobOrganisationList, CCExpJobOrganisationListData]);

    useEffect(() => {
        // console.log(CCExpJobShipperOrganisationBranchListData, "===>");
        if (CCExpJobShipperOrganisationBranchListData) {
            let arr = [];
            CCExpJobShipperOrganisationBranchListData.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOrganisationOptions(arr);
        }
    }, [loadingCCExpJobShipperOrganisationBranchList, CCExpJobShipperOrganisationBranchListData]);


    useEffect(() => {
        // console.log(CCExpJobConsigneeOrganisationBranchListData, "===>");
        if (CCExpJobConsigneeOrganisationBranchListData) {
            let arr = [];
            CCExpJobConsigneeOrganisationBranchListData.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOrganisationOptions(arr);
        }
    }, [loadingCCExpJobConsigneeOrganisationBranchList, CCExpJobConsigneeOrganisationBranchListData])

    const initialValues = {
        discharge_port_id: "",
        nature_of_cargo: "",
        destination_port_id: "",
        total_no_of_pkg: "",
        loose_pkgs: "",
        pkts_in_MAWB: "",
        airline_id: "",
        gross_weight: "",
        gross_weight_type: "",
        flight_No: "",
        flight_date: "",
        shipping_line_id: "",
        vessel_sailing_name: "",
        vessel_sailing_date: "",
        voyage_no: "",
        EGM_No: "",
        EGM_Date: "",
        MAWB_No: "",
        MAWB_Date: "",
        HAWB_No: "",
        HAWB_Date: "",
        net_weight: "",
        net_weight_type: "",
        volume_weight: "",
        volume_weight_type: "",
        chargeable_weight: "",
        chargeable_weight_type: "",
        place_of_receipt: "",
        transhipper_code: "",
        marks_Note: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                // values.id = atob(b64id);
                values.custom_clearance_export_job_id = atob(b64id);
                axios.post(`${adminMainUrl}/api/customClearance/shipment/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error!";
                        if (error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (CCExpJobDetailData && CCExpJobDetailData?.CustomClearanceExportJobShipment) {
            let val = CCExpJobDetailData?.CustomClearanceExportJobShipment;

            formik.setFieldValue("discharge_port_id", Number(val.discharge_port_id));
            formik.setFieldValue("nature_of_cargo", val.nature_of_cargo);
            formik.setFieldValue("destination_port_id", Number(val.destination_port_id));
            formik.setFieldValue("total_no_of_pkg", val.total_no_of_pkg);
            formik.setFieldValue("loose_pkgs", val.loose_pkgs);
            formik.setFieldValue("pkts_in_MAWB", val.pkts_in_MAWB);
            formik.setFieldValue("airline_id", Number(val.airline_id));
            formik.setFieldValue("gross_weight", val.gross_weight);
            formik.setFieldValue("gross_weight_type", val.gross_weight_type);
            formik.setFieldValue("flight_No", val.flight_No);
            formik.setFieldValue("flight_date", val.flight_date);
            formik.setFieldValue("shipping_line_id", Number(val.shipping_line_id));
            formik.setFieldValue("vessel_sailing_name", val.vessel_sailing_name);
            formik.setFieldValue("vessel_sailing_date", val.vessel_sailing_date);
            formik.setFieldValue("voyage_no", val.voyage_no);
            formik.setFieldValue("EGM_No", val.EGM_No);
            formik.setFieldValue("EGM_Date", val.EGM_Date);
            formik.setFieldValue("MAWB_No", val.MAWB_No);
            formik.setFieldValue("MAWB_Date", val.MAWB_Date);
            formik.setFieldValue("HAWB_No", val.HAWB_No);
            formik.setFieldValue("HAWB_Date", val.HAWB_Date);
            formik.setFieldValue("net_weight", val.net_weight);
            formik.setFieldValue("net_weight_type", val.net_weight_type);
            formik.setFieldValue("volume_weight", val.volume_weight);
            formik.setFieldValue("volume_weight_type", val.volume_weight_type);
            formik.setFieldValue("chargeable_weight", val.chargeable_weight);
            formik.setFieldValue("chargeable_weight_type", val.chargeable_weight_type);
            formik.setFieldValue("place_of_receipt", val.place_of_receipt);
            formik.setFieldValue("transhipper_code", val.transhipper_code);
            formik.setFieldValue("marks_Note", val.marks_Note);
        }
    }, [CCExpJobDetailData]);


    const handleGetShipperBranches = (org_id) => {
        if (token && user_id && b64id && org_id) {
            dispatch(getCCExportShipperOrganisationBranchList(token, user_id, org_id));
        }
    };

    const handleGetConsigneeBranches = (org_id) => {
        if (token && user_id && b64id && org_id) {
            dispatch(getCCExportConsigneeOrganisationBranchList(token, user_id, org_id));
        }
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Discharge Port
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector"
                                placeholder="Select Port"
                                name="discharge_port_id"
                                options={portOptions}
                                onChange={option => {
                                    //set values and change branches
                                    formik.setFieldValue('discharge_port_id', option.value);
                                }}
                                value={portOptions.find(option => option.value === formik.values.discharge_port_id) || null}
                                isLoading={loadingCCPortList}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Nature of Cargo
                        </label>
                        <select id="" className="form-control form-control-sm"
                            name="nature_of_cargo"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.nature_of_cargo}
                        >
                            <option value="" disabled>-</option>
                            <option value="C - Containerised">C - Containerised</option>
                            <option value="P - Non Containerised Packaged">P-  CNon ontainerised Packaged</option>
                            <option value="LB- Liquid Bulk">LB- Liquid Bulk</option>
                            <option value="DB- Dry Bulk">DB- Dry Bulk</option>
                            <option value="CP- Cotainerised and Packaged">CP- Cotainerised and Packaged</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Destination Port
                        </label>
                        <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                                className="custom-selector"
                                placeholder="Select Port"
                                name="destination_port_id"
                                options={portOptions}
                                onChange={option => {
                                    //set values and change branches
                                    formik.setFieldValue('destination_port_id', option.value);
                                }}
                                value={portOptions.find(option => option.value === formik.values.destination_port_id) || null}
                                isLoading={loadingCCPortList}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Total No. of Package
                        </label>
                        <input type="text"
                            className="form-control form-control-sm"
                            name="total_no_of_pkg"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.total_no_of_pkg}
                            maxLength={50}
                            onInput={(event) => {
                                let value = event.target.value;
                                value = value.replace(/[^0-9]/g, '');
                                event.target.value = value;
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Loose Packages
                        </label>
                        <input type="text"
                            className="form-control form-control-sm"
                            name="loose_pkgs"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.loose_pkgs}
                            maxLength={50}
                            onInput={(event) => {
                                let value = event.target.value;
                                value = value.replace(/[^0-9]/g, '');
                                event.target.value = value;
                            }}

                        />
                    </div>
                </div>

                {trans_mode == "Air" &&
                    <>
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Pkts in MAWB
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="pkts_in_MAWB"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.pkts_in_MAWB}
                                    maxLength={50}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Airline
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className="custom-selector"
                                        placeholder="Select Organisation"
                                        name="airline_id"
                                        options={airlineOptions}
                                        onChange={option => {
                                            //set values and change branches
                                            formik.setFieldValue('airline_id', option.value);
                                        }}
                                        value={airlineOptions.find(option => option.value === formik.values.airline_id) || null}
                                        isLoading={loadingCCAirlineList}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Flight No.
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="flight_No"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.flight_No}
                                    maxLength={250}

                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Flight Date.
                                </label>
                                <input type="date"
                                    className="form-control form-control-sm"
                                    name="flight_date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.flight_date}
                                />
                            </div>
                        </div>

                    </>}
                {trans_mode == "Sea" &&
                    <>
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Shipping Line
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className="custom-selector"
                                        placeholder="Select Organisation"
                                        name="shipping_line_id"
                                        options={shiplineOptions}
                                        onChange={option => {
                                            //set values and change branches
                                            formik.setFieldValue('shipping_line_id', option.value);
                                        }}
                                        value={shiplineOptions.find(option => option.value === formik.values.shipping_line_id) || null}
                                        isLoading={loadingCCShiplineList}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Vessel Sailing Name
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="vessel_sailing_name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.vessel_sailing_name}
                                    maxLength={250}

                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Vessel Sailing Date
                                </label>
                                <input type="date"
                                    className="form-control form-control-sm"
                                    name="vessel_sailing_date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.vessel_sailing_date}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Voyage No.
                                </label>
                                <input type="text"
                                    maxLength={250}
                                    className="form-control form-control-sm"
                                    name="voyage_no"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.voyage_no}
                                />
                            </div>
                        </div>
                    </>
                }
                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            EGM No.
                        </label>
                        <input type="text"
                            maxLength={250}
                            className="form-control form-control-sm"
                            name="EGM_No"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.EGM_No}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label mb-0">
                            EGM Date
                        </label>
                        <input type="date"
                            className="form-control form-control-sm"
                            name="EGM_Date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.EGM_Date}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            MAWB No.
                        </label>
                        <input type="text"
                            maxLength={250}
                            className="form-control form-control-sm"
                            name="MAWB_No"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.MAWB_No}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label mb-0">
                            MAWB Date
                        </label>
                        <input type="date"
                            className="form-control form-control-sm"
                            name="MAWB_Date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.MAWB_Date}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            HAWB No.
                        </label>
                        <input type="text"
                            maxLength={250}
                            className="form-control form-control-sm"
                            name="HAWB_No"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.HAWB_No}
                        />
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label mb-0">
                            HAWB Date
                        </label>
                        <input type="date"
                            className="form-control form-control-sm"
                            name="HAWB_Date"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.HAWB_Date}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Gross Wt.
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="gross_weight"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.gross_weight}
                                    maxLength={50}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Unit
                                </label>
                                <select
                                    className="form-control form-control-sm"
                                    name="gross_weight_type"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.gross_weight_type}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="NOS">NOS</option>
                                    <option value="BAG">BAG (Bags)</option>
                                    <option value="BGS">BGS (BAGS)</option>
                                    <option value="BLK">BLK (Bulk)</option>
                                    <option value="BLO">BLO (Steel Blocks)</option>
                                    <option value="BLS">BLS (Bails)</option>
                                    <option value="BOX">BOX (Boxes)</option>
                                    <option value="BRL">BRL (Barrel)</option>
                                    <option value="BTL">BTL (Bottles)</option>
                                    <option value="BUL">BUL (Steel Bulk)</option>
                                    <option value="CAN">CAN (Cans)</option>
                                    <option value="CHI">CHI (Chest)</option>
                                    <option value="COL">COL (Collies)</option>
                                    <option value="CON">CON (Container)</option>
                                    <option value="CRI">CRI (Crates)</option>
                                    <option value="CRY">CRY (Carboys)</option>
                                    <option value="CSK">CSK (Wooden Cases)</option>
                                    <option value="CTN">CTN (Cartons)</option>
                                    <option value="CYL">CYL (Cylinder)</option>
                                    <option value="DOZ">DOZ (Dozen)</option>
                                    <option value="DRM">DRM (Drums)</option>
                                    <option value="ENV">ENV (Steel Envelopes)</option>
                                    <option value="FBK">FBK (Habbuck)</option>
                                    <option value="FLK">FLK (Flask)</option>
                                    <option value="FUT">FUT (Futs)</option>
                                    <option value="GRS">GRS (Gross)</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Net Wt.
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="net_weight"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.net_weight}
                                    maxLength={50}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Unit
                                </label>
                                <select
                                    className="form-control form-control-sm"
                                    name="net_weight_type"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.net_weight_type}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="NOS">NOS</option>
                                    <option value="BAG">BAG (Bags)</option>
                                    <option value="BGS">BGS (BAGS)</option>
                                    <option value="BLK">BLK (Bulk)</option>
                                    <option value="BLO">BLO (Steel Blocks)</option>
                                    <option value="BLS">BLS (Bails)</option>
                                    <option value="BOX">BOX (Boxes)</option>
                                    <option value="BRL">BRL (Barrel)</option>
                                    <option value="BTL">BTL (Bottles)</option>
                                    <option value="BUL">BUL (Steel Bulk)</option>
                                    <option value="CAN">CAN (Cans)</option>
                                    <option value="CHI">CHI (Chest)</option>
                                    <option value="COL">COL (Collies)</option>
                                    <option value="CON">CON (Container)</option>
                                    <option value="CRI">CRI (Crates)</option>
                                    <option value="CRY">CRY (Carboys)</option>
                                    <option value="CSK">CSK (Wooden Cases)</option>
                                    <option value="CTN">CTN (Cartons)</option>
                                    <option value="CYL">CYL (Cylinder)</option>
                                    <option value="DOZ">DOZ (Dozen)</option>
                                    <option value="DRM">DRM (Drums)</option>
                                    <option value="ENV">ENV (Steel Envelopes)</option>
                                    <option value="FBK">FBK (Habbuck)</option>
                                    <option value="FLK">FLK (Flask)</option>
                                    <option value="FUT">FUT (Futs)</option>
                                    <option value="GRS">GRS (Gross)</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Volume
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="volume_weight"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.volume_weight}
                                    maxLength={50}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Unit
                                </label>
                                <select
                                    className="form-control form-control-sm"
                                    name="volume_weight_type"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.volume_weight_type}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="CBI">CBI (Cubic Inch)</option>
                                    <option value="CBM">CBM (Cubic Metre)</option>
                                    <option value="CCM">CCM (Cubic Centimetre)</option>
                                    <option value="CFT">CFT (Cubic Foot)</option>
                                    <option value="KLT">KLT (Kilo Litre)</option>
                                    <option value="LTR">LTR (Litre)</option>
                                    <option value="PNT">PNT (Pint)</option>
                                    <option value="UGS">UGS (US Gallons)</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Chargable Wt.
                                </label>
                                <input type="text"
                                    className="form-control form-control-sm"
                                    name="chargeable_weight"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.chargeable_weight}
                                    maxLength={50}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="input_box_section">
                                <label htmlFor="" className="form-label  mb-0">
                                    Unit
                                </label>
                                <select
                                    className="form-control form-control-sm"
                                    name="chargeable_weight_type"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.chargeable_weight_type}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="CAR">CAR (Carat)</option>
                                    <option value="CTM">CTM (CARATS)</option>
                                    <option value="GMS">GMS (Gram)</option>
                                    <option value="KGS">KGS (Kilogram)</option>
                                    <option value="LBS">LBS (POUNDS)</option>
                                    <option value="MGR">MGR (Milligram)</option>
                                    <option value="MTS">MTS (Metric Ton)</option>
                                    <option value="PND">PND (Pound)</option>
                                    <option value="QTL">QTL (Quintal)</option>
                                    <option value="TGM">TGM (Ten Gross)</option>
                                    <option value="TON">TON (Long Ton)</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Place of Receipt
                        </label>
                        <input type="text"
                            className="form-control form-control-sm"
                            name="place_of_receipt"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.place_of_receipt}
                            maxLength={250}

                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Transhipper Code
                        </label>
                        <input type="text"
                            className="form-control form-control-sm"
                            name="transhipper_code"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.transhipper_code}
                            maxLength={250}

                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="input_box_section">
                        <label htmlFor="" className="form-label  mb-0">
                            Marks and Nos
                        </label>
                        <textarea
                            className="form-control form-control-sm unset-textarea-height"
                            name="marks_Note"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.marks_Note}
                        ></textarea>
                    </div>
                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save & Next"}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ShipperTab;
